module.exports = __webpack_public_path__ + "left_b.f593cd40.png";